import { useEffect } from 'react';
import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import { ProjectDrawerTypes } from '@constants/entities/drawers';
import { useProject } from '@context/Project';

const SELECTION_PRESERVING_DRAWERS = new Set<ProjectDrawerTypes>([
  ProjectDrawerTypes.AddRelationship,
  ProjectDrawerTypes.EditRelationship,
]);

const useClearSelectionOnDrawer = () => {
  const { drawer } = useProject();

  useEffect(() => {
    if (!drawer) return;
    if (SELECTION_PRESERVING_DRAWERS.has(drawer.type)) return;

    getMultiSelectionState().clear();
  }, [drawer]);
};

export default useClearSelectionOnDrawer;
